import { Select } from './styles'

export default Select